module.exports = __webpack_public_path__ + "img/woman.77be5dc5.png";